import {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
  useContext,
} from 'react'
import { SearchProviderProps, SearchProviderState } from './types'
import { useSearchParams } from '@/hooks/useSearchParams'
import { useSearchHistory } from '../../hooks/useSearchHistory'
import { useDebounce } from '@lounge-fe/ui-kit'

const SearchContext = createContext<SearchProviderState>({
  onClear: () => {},
  search: '',
  setSearch: () => {},
})

export const useSearchContext = () => useContext(SearchContext)

export const SearchProvider = ({ children }: SearchProviderProps) => {
  const { searchParams } = useSearchParams()
  const [search, setSearch] = useState(searchParams.get('q') ?? '')

  const { handleSearchChange } = useSearchHistory()

  useEffect(() => {
    handleSearchChange(search)
  }, [search])

  const onClear = useCallback(() => {
    setSearch('')
  }, [])

  const context = useMemo<SearchProviderState>(
    () => ({
      onClear,
      search,
      setSearch,
    }),
    [onClear, search],
  )

  return (
    <SearchContext.Provider value={context}>
      {typeof children === 'function' ? children(context) : children}
    </SearchContext.Provider>
  )
}
